import Component from '@glimmer/component';
import EmberObject, { action } from '@ember/object';
import { task } from 'ember-concurrency';
import FormValidations from 'cio/utils/form-validations';
import UserModel from 'cio/models/user';

let Validations = {
  code(value: string) {
    if (!value?.trim()) {
      return "Authentication code can't be blank.";
    }

    return true;
  },
};

interface FormValues extends EmberObject {
  code: string;
}

/*
 * template-less component class
 * extended by two-factor-auth/totp-form/setup-guide and two-factor-auth/totp-form/personal-security-settings:
 * representing component with same logic, similar copy, but somehow different HTML markup - mostly for styling reasons in specific context
 */
interface TwoFactorAuthTotpFormBaseComponentArgs {
  user: UserModel;
  secret: string;
  readOnly?: boolean;
  codeInputErrors?: string[];
  resetCodeInputErrors: () => unknown;
  onSubmit: (code: string) => Promise<unknown>;
  onBack?: () => unknown;
}

export default class TwoFactorAuthTotpFormBaseComponent extends Component<TwoFactorAuthTotpFormBaseComponentArgs> {
  validations!: FormValidations;

  _formValues: FormValues = EmberObject.create({ code: '' });

  constructor(owner: unknown, args: TwoFactorAuthTotpFormBaseComponentArgs) {
    super(owner, args);

    this.validations = FormValidations.create({ validations: Validations, context: this, modelKey: '_formValues' });
  }

  get readOnly() {
    return this.args.readOnly ?? false;
  }

  get qrCodeContent(): string {
    let { secret } = this.args;
    return `otpauth://totp/Customer.io:${this.args.user.email}?secret=${secret}&issuer=Customer.io`;
  }

  submitTask = task(async (evt?: Event) => {
    evt?.preventDefault();

    try {
      await this.validations.validateModel();
    } catch (e) {
      // `validateModel` already found and set validation errors
      // return early to avoid executing real submit logic
      return;
    }

    await this.args.onSubmit(this._formValues.code);
  });

  @action
  handleCodeInput(val: string) {
    this.args.resetCodeInputErrors();
    this._formValues.set('code', val);
    this.validations.validateAttribute('code');
  }
}
